<template>
	<div>
		<v-dialog
			:model-value="dialogVisible"
			persistent
			:width="$vuetify.display.mobile ? '95%' : '500px'"
		>
			<v-card class="sgnl-p-16">
				<v-card-text class="sgnl-flex sgnl-align-center sgnl-gap-12">
					<LogoGithub16 class="sgnl-flex-shrink-0 sgnl-icon-color-secondary" />
					<span class="sgnl-text-color-default">{{ dialogText }}</span>
					<v-progress-circular
						v-if="status === 'loading'"
						:width="3"
						color="var(--sgnl-brand-background)"
					/>
					<CheckmarkOutline16
						v-else-if="status === 'success'"
						class="sgnl-flex-shrink-0 sgnl-icon-color-brand"
					/>
					<Warning16
						v-else-if="status === 'error'"
						class="sgnl-flex-shrink-0 sgnl-icon-color-error"
					/>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import CheckmarkOutline16 from "@carbon/icons-vue/es/checkmark--outline/16";
import Warning16 from "@carbon/icons-vue/es/warning/16";
import LogoGithub16 from "@carbon/icons-vue/es/logo--github/16";

export default defineComponent({
	name: "GithubAuthRedirectDialog",
	components: { CheckmarkOutline16, Warning16, LogoGithub16 },
	props: {
		dialogVisible: { type: Boolean, default: false },
		dialogText: { type: String, default: "Authenticating with GitHub..." },
		status: {
			type: String,
			default: "loading",
			validator: (v: string) => ["loading", "success", "error"].includes(v),
		},
	},
});
</script>

<style scoped></style>
